/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type OrgComplianceSettingsResponseCandidateNameDisplayMode = typeof OrgComplianceSettingsResponseCandidateNameDisplayMode[keyof typeof OrgComplianceSettingsResponseCandidateNameDisplayMode];


export const OrgComplianceSettingsResponseCandidateNameDisplayMode = {
  show_all: 'show_all',
  anonymized: 'anonymized',
  initials_only: 'initials_only',
} as const;
